import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ssvj_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("ssvj_token", t);
  else localStorage.removeItem("ssvj_token");
};

export const getToken = () => localStorage.getItem("ssvj_token");
